import { gql } from '../../__generated__/gql'

export const CHAT_AI_MESSAGE_USER_REACTION_MUTATION = gql(`
  mutation chatAiMessageUserReaction(
    $threadId: Int!,
    $messageId: String!,
    $userReaction: ChatAiThreadMessageUserReactionEnum!
  ) {
      chatAiMessageUserReaction(
        input: {
          threadId: $threadId,
          messageId: $messageId,
          userReaction: $userReaction
        }
      ) {
          chatAiThreadMessage {
            id
            content
            author
            saved
            userReaction
          }
        }
    }
`)
